'use client';

import styles from './ClientChatHeader.module.css';
import type { ClientChatHeaderProps } from './ClientChatHeader.types';
import { ClientConversationsContext } from '@/_contexts/client/ClientConversationsProvider';
import {
  Avatar,
  Flex,
  Text,
  Button,
  ButtonGroup,
  Tooltip,
} from '@/_components';
import { useContext, type FC } from 'react';
import { getAllConversationNames } from '@/_utils/conversations';
import { useRouter } from 'next/navigation';

export const ClientChatHeader: FC<ClientChatHeaderProps> = () => {
  const { selectedMessage: conversation } = useContext(
    ClientConversationsContext,
  );
  const { push } = useRouter();

  const isFilteredView: boolean = true;
  const backPath: string = '/';
  const backValue: string = 'Back to Dashboard';

  const conversationNames = getAllConversationNames(conversation);

  const onInboxClick = () => push(backPath);

  return (
    <>
      <Flex className={styles.chatHeader} isBetween={true}>
        {conversation && (
          <Flex isYCentered={true} gap={4}>
            {isFilteredView && (
              <ButtonGroup>
                <Button
                  onClick={onInboxClick}
                  value={backValue}
                  iconLeft="caret-left"
                  size="small"
                  isIconOnly={true}
                  intent="secondary"
                />
              </ButtonGroup>
            )}
            <Flex gap={2}>
              {conversationNames?.map((name, key) => {
                const isAdvisorType: boolean =
                  conversation?.advisor_names?.includes(name);

                return (
                  <Tooltip key={key}>
                    <Tooltip.Content>
                      <Text type="small" color="currentcolor" isEllipsis={true}>
                        {name}
                      </Text>
                    </Tooltip.Content>
                    <Tooltip.Trigger>
                      <Avatar
                        type={isAdvisorType ? 'firm' : 'user'}
                        size={32}
                        name={name}
                      />
                    </Tooltip.Trigger>
                  </Tooltip>
                );
              })}
            </Flex>
          </Flex>
        )}
      </Flex>
    </>
  );
};
